<script>
import TextAttributeBase from './TextAttributeBase';

export default {
        extends: TextAttributeBase,
        data() {
            return {
                id: _.uniqueId('TextAttributeInput-items-'),
            }
        },
        mounted() {
            new Sortable.default(document.getElementById(this.id), {
                animation: 150,
                handle: ".dragHandle",
                onUpdate: (evt) => {
                    this.updatePosition(this.$refs['values'].children);
                },
            });
        },
        computed: {
            textLength() {
                return this.storeValueData.text_attribute_value_text ? this.storeValueData.text_attribute_value_text.length : 0;
            },
            canSave() {
                return !!this.storeValueData.text_attribute_value_text;
            },
            editLength() {
                if (this.updateValueData.text_attribute_value_text) {
                    return this.updateValueData.text_attribute_value_text.length;
                }

                return '0';
            }
        },
        methods: {
            selectToUpdateDropdown(value) {
                if (value.text_attribute_value) {
                    value.text_attribute_value_text = value.text_attribute_value.text
                }

                this.selectToUpdate(value);
            },
            updatePosition(children) {
                _.forEach(children, (child, index) => {
                    _.forEach(this.attribute.values, function (attrValue) {
                       if (attrValue.id == child.getAttribute('data-id')) {
                           attrValue.position = index+1;
                       }
                    });
                });

                _.forEach(this.attribute.values, (value) => {
                    Vue.nextTick(() => {
                        this.updateValueData = value;
                        this.updateValue(true, false);
                    });
                });
            },
          saveValue() {
              if (!this.canSave) {
                return;
              }

              this.storeValue();
            }
        },
    }
</script>

<style>
    .dragHandle {
        cursor: grab;
    }
</style>

<template>
    <div :class="[withCols ? 'col-lg-4': '']">
        <div class="panel panel-default">
            <div class="panel-heading">
                <span v-html="headline"></span>
                <a v-if="canSave" class="pull-right" @click="storeValue"><i class="fa fa-save"></i></a>
                <i class="pull-right fa fa-lock" v-if="isLocked"></i>
            </div>
            <div class="panel-body" :id="id" ref="values">
                <div class="row m-b-sm" v-for="value in attribute.values" :data-id="value.id">
                    <div v-if="isLocked">
                        <div class="col-lg-12">
                            <div class="input-group">
                                <input readonly type="text" class="form-control"
                                       :value="value.text_attribute_value ? value.text_attribute_value.text : ''">
                                <span class="input-group-addon">
                                         <i class="fa fa-i-cursor" aria-hidden="true"></i>
                                        <span v-text="value.text_attribute_value && value.text_attribute_value.text ? value.text_attribute_value.text.length : ''"></span>
                                     </span>
                            </div>
                        </div>
                    </div>
                    <Lightbox
                            v-if="!isLocked"
                            :id="lightboxId(value.id)"
                            :headline="headline"
                    >
                        <span slot="open-template" @click="selectToUpdateDropdown(value)">
                            <div class="col-lg-12">
                                <div class="input-group">
                                    <div class="input-group-addon dragHandle"
                                         v-if="attribute.max_positions > 1 && attribute.values.length > 1">
                                        <i class="fa fa-bars" aria-hidden="true"></i>
                                    </div>
                                    <input type="text" class="form-control"
                                           :value="value.text_attribute_value ? value.text_attribute_value.text : ''">
                                     <span class="input-group-addon">
                                         <i class="fa fa-i-cursor" aria-hidden="true"></i>
                                        <span v-text="value.text_attribute_value && value.text_attribute_value.text ? value.text_attribute_value.text.length : ''"></span>
                                     </span>
                                 </div>
                            </div>
                        </span>
                        <div slot="body" class="text-left">
                            <div class="row">
                                <div class="input-group m-b">
                                    <input type="text" v-model="updateValueData.text_attribute_value_text" class="form-control"
                                           @keyup.enter="updateValue" autofocus>
                                    <span class="input-group-addon">
                                         <i class="fa fa-i-cursor" aria-hidden="true"></i>
                                        <span v-text="editLength"></span>
                                     </span>
                                </div>
                            </div>
                        </div>
                        <div v-cloak slot="footer">
                            <div class="pull-left">
                                <button type="button" class="btn btn-danger" @click="deleteValue(value.id)" v-text="__('scoop-os.common.delete')"></button>
                            </div>
                            <button type="button" class="btn btn-white" @click="updateValueData = {}"
                                    data-dismiss="modal" v-text="__('scoop-os.common.close')">
                            </button>
                            <button class="btn btn-primary" @click="updateValue">Update</button>
                        </div>
                    </Lightbox>
                </div>
                <div class="row" v-if="!isLocked && canAddAnotherValue">
                    <div class="col-lg-12">
                        <div class="input-group">
                            <input type="text" v-model="storeValueData.text_attribute_value_text" class="form-control"
                                   @keyup.enter="saveValue">
                            <span class="input-group-addon">
                                 <i class="fa fa-i-cursor" aria-hidden="true"></i>
                                <span v-text="textLength"></span>
                             </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
